
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<ComparisonBar>({})
export default class ComparisonBar extends Vue {
    @Prop({ type: Number, default: 0 }) public value!: number
    @Prop({ type: Number, default: -100 }) public min!: number
    @Prop({ type: Number, default: 100 }) public max!: number
    @Prop({ type: Number, default: 0 }) public average!: number
    @Prop({ type: String, default: '' }) public averageText!: string
    @Prop({ type: String, default: '#D5DEFF' }) public positiveColor!: string
    @Prop({ type: String, default: '#FCC3A8' }) public negativeColor!: string
    @Prop({ type: String, default: '#ebebeb' }) public bgColor!: string
    @Prop({ type: Boolean, default: false }) public last!: boolean // show short vertical line for last row
    @Prop({ type: Boolean, default: false }) public showlabel!: boolean

    get range(): number {
        return this.max - this.min
    }

    get middleRelative() {
        return this.average - this.min
    }

    get middlePercent(): number {
        const value =
            this.range > 0 ? (this.middleRelative / this.range) * 100 : 50
        return Math.max(0, Math.min(100, value))
    }

    get valueRelative() {
        return this.value - this.min
    }

    get delta() {
        return this.value - this.average
    }

    get deltaPercent() {
        return this.range > 0 ? (this.delta / this.range) * 100 : 0
    }

    get deltaWidthPercent() {
        const value = Math.abs(this.deltaPercent)
        return Math.max(0, Math.min(value, 100))
    }

    get deltaPositionRelative() {
        let value
        if (this.deltaPercent < 0) {
            value = this.middlePercent + this.deltaPercent
        } else {
            value = this.middlePercent
        }
        return Math.max(0, Math.min(100, value))
    }

    get color() {
        if (this.deltaPercent > 0) {
            return this.positiveColor
        } else {
            return this.negativeColor
        }
    }
}
